<template>
    <div class="chat-interface" v-if="activeConversation">
      <div class="chat-header">
        <h2>{{ activeConversation.name }}</h2>
        <button @click="renameConversation" class="rename-btn">重命名</button>
      </div>
      
      <div class="messages-container">
        <div 
          v-for="(message, index) in activeConversation.messages" 
          :key="index"
          class="message"
          :class="{ 'user-message': message.sender === 'user', 'ai-message': message.sender === 'ai' }"
        >
          <div class="message-sender">
            {{ message.sender === 'user' ? '我' : 
               activeConversation.aiType === 'painting' ? '绘画AI' :
               activeConversation.aiType === 'chatGLM' ? 'ChatGLM' : 'AutoGLM' }}
          </div>
          <div class="message-content">{{ message.content }}</div>
          <div class="message-time">{{ formatTime(message.timestamp) }}</div>
        </div>
      </div>
      
      <div class="message-input-area">
        <textarea 
          v-model="newMessage" 
          placeholder="输入消息..."
          @keydown.enter.prevent="sendMessage"
        ></textarea>
        <button @click="sendMessage" class="send-btn">发送</button>
      </div>
    </div>
    
    <div class="no-conversation" v-else>
      请从左侧选择或创建一个对话
    </div>
  </template>
  
  <script>
  export default {
    computed: {
      activeConversation() {
        return this.$store.getters.activeConversation;
      }
    },
    
    data() {
      return {
        newMessage: ''
      };
    },
    
    methods: {
      async sendMessage() {
        if (!this.newMessage.trim() || !this.activeConversation) return;
        
        // 创建用户消息
        const userMessage = {
          sender: 'user',
          content: this.newMessage.trim()
        };
        
        // 添加用户消息到对话
        await this.$store.dispatch('addMessageToConversation', {
          conversationId: this.activeConversation.id,
          message: userMessage
        });
        
        // 清空输入框
        this.newMessage = '';
        
        // 模拟AI回复
        setTimeout(async () => {
          const aiResponses = {
            painting: '这是根据你的描述生成的绘画...',
            chatGLM: '这是ChatGLM的回复内容...',
            autoGLM: '这是AutoGLM的回复内容...'
          };
          
          const aiMessage = {
            sender: 'ai',
            content: aiResponses[this.activeConversation.aiType]
          };
          
          await this.$store.dispatch('addMessageToConversation', {
            conversationId: this.activeConversation.id,
            message: aiMessage
          });
        }, 1000);
      },
      
      async renameConversation() {
        const newName = prompt('请输入新的对话名称', this.activeConversation.name);
        if (newName && newName !== this.activeConversation.name) {
          await this.$store.dispatch('updateConversationName', {
            conversationId: this.activeConversation.id,
            newName
          });
        }
      },
      
      formatTime(timeString) {
        if (!timeString) return '';
        const date = new Date(timeString);
        return date.toLocaleTimeString();
      }
    }
  };
  </script>
  
  <style scoped>
  .chat-interface {
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
  }
  
  .chat-header {
    padding: 16px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .rename-btn {
    padding: 4px 8px;
    font-size: 12px;
    background-color: #f0f0f0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .rename-btn:hover {
    background-color: #e0e0e0;
  }
  
  .messages-container {
    flex: 1;
    padding: 16px;
    overflow-y: auto;
    background-color: #f9f9f9;
  }
  
  .message {
    max-width: 80%;
    margin-bottom: 16px;
    padding: 10px;
    border-radius: 8px;
  }
  
  .user-message {
    background-color: #e3f2fd;
    margin-left: auto;
  }
  
  .ai-message {
    background-color: #fff;
    border: 1px solid #e0e0e0;
  }
  
  .message-sender {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
  }
  
  .message-content {
    margin-bottom: 4px;
  }
  
  .message-time {
    font-size: 11px;
    color: #999;
    text-align: right;
  }
  
  .message-input-area {
    padding: 16px;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 8px;
  }
  
  .message-input-area textarea {
    flex: 1;
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    resize: none;
    min-height: 60px;
  }
  
  .send-btn {
    padding: 8px 16px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    align-self: flex-end;
  }
  
  .send-btn:hover {
    background-color: #359e75;
  }
  
  .no-conversation {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    border: 1px dashed #e0e0e0;
    border-radius: 4px;
  }
  </style>
  